<script>
    import nl2p from '@/filters/nl2p';

    export default {
        name: 'Nl2p',
        props: {
            classes: {
                type: [Object, Array, String],
                default: '',
            },
        },
        render(h) {
            const html = nl2p(this.$slots.default[0].text);

            return h('div', { class: this.classes, domProps: { innerHTML: html } });
        },
    };
</script>
